import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import UPGRADE_IMAGE_CERTIFICATE from 'assets/images/upgrade-image-certificate.webp';
import LI_DOT from 'assets/images/li-dot.webp';
import { Img } from 'common/components/Img';
import { PageTitle } from 'common/components/PageTitle';
import { PlanDemo } from 'common/components/PlanDemo';

export const UpgradeContent = () => {
    const [translate] = useTranslation();

    return (
        <Box sx={{ mt: 8, mb: 4 }}>
            <PageTitle>{translate('certificatesUpgradePageTitle')}</PageTitle>
            <Grid
                container
                sx={{ mt: 0.5, flexWrap: 'wrap', alignItems: 'center' }}
            >
                <Grid size={{ md: 6, sm: 12 }} sx={{ mb: 2, pr: { md: 4 } }}>
                    <Typography
                        sx={{
                            color: 'primary.main',
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            fontSize: 14,
                        }}
                    >
                        {translate('plans.certificate.moduleTitle')}
                    </Typography>

                    <Typography sx={{ mb: 2 }} variant="h1">
                        {translate('plans.certificate.title')}
                    </Typography>

                    <Typography lineHeight="1.6" sx={{ mb: 2 }}>
                        {translate('plans.certificate.text')}
                    </Typography>

                    <Typography fontWeight={700}>
                        {translate('plans.certificate.advantagesText')}
                    </Typography>

                    <Box sx={{ mt: 1 }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                mb: 1,
                            }}
                        >
                            <Box
                                sx={{
                                    backgroundImage: `url(${LI_DOT})`,
                                    backgroundSize: '20px',
                                    backgroundRepeat: 'no-repeat',
                                    height: 20,
                                    width: 20,
                                    mr: 2,
                                    flexShrink: 0,
                                }}
                            />

                            <Typography lineHeight="1.6">
                                {translate(
                                    'plans.certificate.advantages.advantage1'
                                )}
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                mb: 1,
                            }}
                        >
                            <Box
                                sx={{
                                    backgroundImage: `url(${LI_DOT})`,
                                    backgroundSize: '20px',
                                    backgroundRepeat: 'no-repeat',
                                    height: 20,
                                    width: 20,
                                    mr: 2,
                                    flexShrink: 0,
                                }}
                            />

                            <Typography lineHeight="1.6">
                                {translate(
                                    'plans.certificate.advantages.advantage2'
                                )}
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                mb: 1,
                            }}
                        >
                            <Box
                                sx={{
                                    backgroundImage: `url(${LI_DOT})`,
                                    backgroundSize: '20px',
                                    backgroundRepeat: 'no-repeat',
                                    height: 20,
                                    width: 20,
                                    mr: 2,
                                    flexShrink: 0,
                                }}
                            />

                            <Typography lineHeight="1.6">
                                {translate(
                                    'plans.certificate.advantages.advantage3'
                                )}
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                mb: 1,
                            }}
                        >
                            <Box
                                sx={{
                                    backgroundImage: `url(${LI_DOT})`,
                                    backgroundSize: '20px',
                                    backgroundRepeat: 'no-repeat',
                                    height: 20,
                                    width: 20,
                                    mr: 2,
                                    flexShrink: 0,
                                }}
                            />

                            <Typography lineHeight="1.6">
                                {translate(
                                    'plans.certificate.advantages.advantage4'
                                )}
                            </Typography>
                        </Box>
                    </Box>
                    <PlanDemo sx={{ mt: 2 }} />
                </Grid>

                <Grid size={{ md: 6, sm: 12 }}>
                    <Img src={UPGRADE_IMAGE_CERTIFICATE} />
                </Grid>
            </Grid>
        </Box>
    );
};
